type DividerProps = Readonly<{
  text: string;
  className?: string;
}>;

export const Divider = ({ text, className }: DividerProps) => {
  return (
    <div className={`flex items-center gap-4 ${className}`}>
      <div className="flex-1">
        <hr className="h-px bg-gray-200 border-0 rounded" />
      </div>
      <div className="px-2 text-sm font-medium text-globe-grey text-low-emphasis">{text}</div>
      <div className="flex-1">
        <hr className="h-px bg-gray-200 border-0 rounded" />
      </div>
    </div>
  );
};
